function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.0943 21.1585C13.812 21.8012 13.1699 22.25 12.4229 22.25C11.676 22.25 11.0339 21.8012 10.7516 21.1585H14.0943Z",
  fill: "#ff0000"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.2857 1C11.3389 1 10.5714 1.76751 10.5714 2.71429V3.79816C8.35135 4.48312 6.52004 6.40657 6.52004 9.53999V13.7866L4.20293 17.1903C3.95885 17.5489 3.93304 18.0129 4.13585 18.3963C4.33865 18.7797 4.73679 19.0195 5.17052 19.0195H19.6752C20.109 19.0195 20.5071 18.7797 20.7099 18.3963C20.9128 18.0129 20.8869 17.5488 20.6429 17.1903L18.3258 13.7865V9.53994C18.3258 6.21454 16.3415 4.2786 14 3.69996V2.71429C14 1.76751 13.2325 1 12.2857 1Z",
  fill: "#ff0000"
});

const SvgBell2 = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "#ff0000",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBell2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Bell2.d091afbd.svg";
export { ForwardRef as ReactComponent };